import {SetGetListOrganization} from './thunk/setGetListOrganization';
import {SetPostCreateOrganization} from './thunk/setPostCreateOrganization';
import {SetPostUpdateOrganization} from './thunk/setPostUpdateOrganization';

export const Thunks = {
    SetGetListOrganization,
    SetPostCreateOrganization,
    SetPostUpdateOrganization
}